import { render, staticRenderFns } from "./CateringsTable.vue?vue&type=template&id=299bd7e6&"
import script from "./CateringsTable.vue?vue&type=script&lang=js&"
export * from "./CateringsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports